import type { DataTableFilterMeta } from 'primereact/datatable';

/** Проверяет, является ли набор фильтров объектом */
const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

/** Подготавливает фильтры таблицы */
export const normalizeDataTableFilters = (value: unknown): DataTableFilterMeta => {
    const candidate = isRecord(value) && isRecord(value.filters)
        ? value.filters
        : value;

    return isRecord(candidate)
        ? candidate as DataTableFilterMeta
        : {};
};

/** Получает значение фильтра */
export const getDataTableFilterValue = (filters: DataTableFilterMeta, key: string): unknown => {
    const filter = filters[key];

    if (!filter) return undefined;

    return 'constraints' in filter
        ? filter.constraints[0]?.value
        : filter.value;
};

/** Получает непустое строковое значение фильтра */
export const asNonEmptyFilterString = (value: unknown): string | undefined =>
    typeof value === 'string' && value.trim() !== ''
        ? value.trim()
        : undefined;

/** Получает числовое значение фильтра */
export const asFiniteFilterNumber = (value: unknown): number | undefined =>
    typeof value === 'number' && Number.isFinite(value)
        ? value
        : undefined;

/** Проверяет массивоподобное значение */
export const asGuardedFilterArray = <T>(
    value: unknown,
    predicate: (item: unknown) => item is T,
): T[] => Array.isArray(value)
        ? value.filter(predicate)
        : [];
